import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../state/AuthContext.jsx';
import { useNotice } from '../../state/NoticeContext.jsx';
import { Button, Card, Text } from '../../ui.jsx';

export default function SignUp() {
  const { register } = useAuth();
  const notice = useNotice();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const [busy, setBusy] = useState(false);
  const [devCode, setDevCode] = useState('');

  const set = (key) => (event) => setForm({ ...form, [key]: event.target.value });

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setDevCode('');
    try {
      const data = await register({
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim() || undefined,
        password: form.password
      });
      notice.success(data.message || 'Account created.');
      // Without a mail key the API returns the code so local work is possible.
      if (data.devCode) {
        setDevCode(data.devCode);
        setForm({ name: '', email: form.email, phone: '', password: '' });
        return;
      }
      navigate('/verify-email', { state: { email: form.email.trim() } });
    } catch (error) {
      notice.fromError(error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="authw">
      <Card>
        <h1 style={{ fontSize: 24, marginBottom: 4 }}>Create your profile</h1>
        <p className="mu" style={{ marginBottom: 16 }}>
          Your bio data, results and documents are saved once and reused for each school you apply to.
        </p>
        <form onSubmit={submit}>
          <Text
            label="Full name"
            required
            autoComplete="name"
            value={form.name}
            onChange={set('name')}
          />
          <div style={{ height: 12 }} />
          <Text
            label="Email"
            type="email"
            required
            autoComplete="email"
            value={form.email}
            onChange={set('email')}
          />
          <div style={{ height: 12 }} />
          <Text
            label="Phone"
            type="tel"
            autoComplete="tel"
            hint="Used by schools only if they need to reach you about an application."
            value={form.phone}
            onChange={set('phone')}
          />
          <div style={{ height: 12 }} />
          <Text
            label="Password"
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            hint="At least 8 characters."
            value={form.password}
            onChange={set('password')}
          />
          <div style={{ height: 16 }} />
          <Button type="submit" busy={busy} style={{ width: '100%' }}>Create account</Button>
        </form>

        {devCode ? (
          <div className="note">
            <b>Email is not configured on this server.</b>
            <div className="mu" style={{ margin: '4px 0 10px' }}>
              The API returned your verification code so you can continue locally. It is not sent to
              anyone and stops working as soon as a mail key is added.
            </div>
            <code style={{ fontSize: 20, fontWeight: 800, letterSpacing: '0.1em' }}>{devCode}</code>
            <div style={{ marginTop: 10 }}>
              <Button
                size="sm"
                onClick={() => navigate('/verify-email', { state: { email: form.email } })}
              >
                Enter this code
              </Button>
            </div>
          </div>
        ) : null}

        <p className="mu" style={{ marginTop: 16, textAlign: 'center' }}>
          Already have an account? <Link to="/signin">Log in</Link>
        </p>
      </Card>
    </div>
  );
}
